import { Shadow, TableItem, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { ResponsesPeriodResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Text } from 'native-base';
import React from 'react';

import { dataContent } from '../../../../../../constants';
import { validateAndFormatValue } from '../../../../Table/constants';
import { TableHead } from '../TableHead';

interface DetailsProfitablityPeriodTableProps {
  data: ResponsesPeriodResponse;
}

export const DetailsProfitablityPeriodTable: React.FC<DetailsProfitablityPeriodTableProps> = ({
  data,
}) => {
  const viewportType = useBreakpointValue({ base: 'tablet', lg: 'desktop' });
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const { tableHead, widthCols } = dataContent.pensionProfitabilityPeriodStatements;

  const initialDate = validateAndFormatValue(data?.initialReferenceDate, 'date');
  const finalDate = validateAndFormatValue(data?.finalReferenceDate, 'date');
  const profitability = validateAndFormatValue(data?.profitability, 'percentage');

  const itemResponsive = useBreakpointValue({
    base: (
      <Shadow level={3} borderRadius={BoxRadius.sm}>
        <HStack
          alignItems={'center'}
          justifyContent={'space-between'}
          p={Spacing['inline.xxxs']}
          borderRadius={BoxRadius.sm}>
          <Text fontSize={Typography['fontsize.md']} color={'neutral.black'} variant={'regular'}>
            Aliquota incidente(%)
          </Text>
          <Text fontSize={Typography['fontsize.md']} color={'neutral.darkest'} variant={'regular'}>
            {profitability}
          </Text>
        </HStack>
      </Shadow>
    ),
    sm: (
      <TableItem
        testId="statement-pension-profitability-period-incidentAliquot"
        width={widthCols.incidentAliquot.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {profitability}
        </Text>
      </TableItem>
    ),
  });

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
        Rentabilidade no período de {initialDate} - {finalDate}
      </Text>
      <VStack space={Spacing['stack.xxxs']}>
        {!isMobile && (
          <TableHead viewportType={viewportType} tableHead={tableHead} widthCols={widthCols} />
        )}
        {itemResponsive}
      </VStack>
    </VStack>
  );
};
